import { ApolloError } from "@apollo/client"
import { GraphQLError, GraphQLFormattedError } from "graphql"
import { toast } from "~/ui/use-toast"

/** based on app/graphql/validation_error.rb */
type ValidationError = {
  field: string
  resource: string
  fullMessage: string
  message: string
  type: string
}

type ValidationErrorPayload = {
  extensions: {
    code: "VALIDATION_ERROR"
    validationErrors: Array<ValidationError>
  }
  message: string
}

const isApolloError = (t: readonly GraphQLFormattedError[] | ApolloError): t is ApolloError => {
  return (t as ApolloError).graphQLErrors !== undefined
}

const getGraphqlErrors = (_errors?: readonly GraphQLFormattedError[] | ApolloError) => {
  if (!_errors) return
  let errors: Array<GraphQLError | GraphQLFormattedError> = []

  if (isApolloError(_errors)) {
    errors = [..._errors.graphQLErrors]
  } else {
    errors = [..._errors]
  }

  return errors
}

const isBaseError = (ve: ValidationError) => ve.field === "base"

const baseErrorMessages = (payload: ValidationErrorPayload) =>
  (payload.extensions.validationErrors ?? []).filter(isBaseError).map((ve) => ve.fullMessage)

const displayErrors = (_errors?: readonly GraphQLFormattedError[] | ApolloError) => {
  console.log("got errors", _errors)

  if (!_errors) return
  const errors = getGraphqlErrors(_errors)

  const validationErrors = errors?.find((error) => error.extensions?.code === "VALIDATION_ERROR")

  if (validationErrors) {
    const payload = validationErrors as unknown as ValidationErrorPayload
    toast({
      title: validationErrors.message || "An error has occurred, please try again",
      description: baseErrorMessages(payload).join(". ") || undefined,
      variant: "destructive",
    })
  } else if (isApolloError(_errors)) {
    toast({
      title: _errors.message || "An error has occurred, please try again",
      variant: "destructive",
    })
  }
}

export {
  baseErrorMessages,
  displayErrors,
  getGraphqlErrors,
  isBaseError,
  type ValidationErrorPayload,
}
